import { useI18n, type Composer } from 'vue-i18n'

export const translations = {
  'pt-br': {
    ErpApp: 'ERP',
    OnlineStoreApp: 'Loja Online',
    StoreApp: 'Loja',
    PaymentsApp: 'Pagamentos',
    SoonBadge: 'Breve',
    SoonTooltipStore: 'A solução Meu Delivery estará disponível em breve.',
    SoonTooltipPayments: 'A solução Pagamentos estará disponível em breve.'
  },
  en: {
    ErpApp: 'ERP',
    OnlineStoreApp: 'Online Store',
    StoreApp: 'Store',
    PaymentsApp: 'Payments',
    SoonBadge: 'Soon',
    SoonTooltipStore: 'The Store solution will be available soon.',
    SoonTooltipPayments: 'The Payments solution will be available soon.'
  },
  es: {
    ErpApp: 'ERP',
    OnlineStoreApp: 'Tienda Online',
    StoreApp: 'Tienda',
    PaymentsApp: 'Pagos',
    SoonBadge: 'Pronto',
    SoonTooltipStore: 'La solución Tienda estará disponible pronto.',
    SoonTooltipPayments: 'La solución Pagos estará disponible pronto.'
  }
}

export function useMenuAppContextsTranslation (): Composer<typeof translations> {
  const i18n = useI18n()

  try {
    for (const [key, values] of Object.entries(translations)) {
      i18n.mergeLocaleMessage(key, values)
    }
  } catch {
    /* empty */
  }

  return useI18n({ messages: translations })
}
